import React from 'react'

import style from './ThreeColumnLayout.module.scss'

const ThreeColumnLayout = ({
  children,
  alignment,
  padding=true,
  displaySidebar,
  setDisplaySidebar,
  valign
}) => (
  <div className={ style.layout } data-alignment={alignment} data-padding={padding} data-valign={valign}>
    <aside data-show={displaySidebar} onClick={() => setDisplaySidebar(false)}>
      <div>{ children[0] }</div>
    </aside>
    <main className={ style.body } data-alignment={alignment}>
      { children[1] }
    </main>
    <nav>
      <div>{ children[2] }</div>
    </nav>
  </div>
)

export default ThreeColumnLayout
